import { HTMLAttributeReferrerPolicy } from "react";

interface Props {
  src: string;
}

function YoutubeIframe(props: Props) {
  const maxWidth = 700;
  const width = Math.min(maxWidth, document.documentElement.clientWidth, window.innerWidth || 0) - 100;
  const height = width * 0.56;

  const iframeStyle = {
    "borderRadius": "10px",
    height,
    width,
  };
  const iframeAttributes = {
    style: iframeStyle,
    src: props.src,
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerPolicy: "strict-origin-when-cross-origin" as HTMLAttributeReferrerPolicy,
    allowFullScreen: true,
  };
  // IframeResizer library has some wierd bugs.  Just use intial size, don't need realtime adjust
  // const iframeResizerOptions = {
  //   license: "GPLv3",
  //   direction: "both" as any,
  //   log: "collapsed" as any,
  // };
  return (
    <div className="centered-list-of-stuff">
      <iframe {...iframeAttributes} />
    </div>
  );
}

export default YoutubeIframe;
